import Typography, { TypographyProps } from "@mui/material/Typography";
import React, { ReactNode } from "react";

interface FormThirdTitleProps extends Omit<TypographyProps, "variant" | "title"> {
  title: ReactNode;
}

export const FormThirdTitle: React.FC<FormThirdTitleProps> = ({ title, ...props }) => (
  <Typography variant="h4" {...props}>
    {title}
  </Typography>
);
